import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetoayodhyatourpackages() {



  const cardData =
  {
    keyword: 'Pune to Ayodhya Tour Package',
    heading: 'Sanavi Travels: Pune to Ayodhya Tour Package',
    headingDescription: 'Sanavi Travels offers Pune to Ayodhya Tour Package, providing safe, comfortable, and well-organized transportation for devotees, families, and group travelers visiting the holy city of Ayodhya. Our fleet of well-maintained AC and Non-AC buses, mini buses, and luxury coaches ensures spacious seating, smooth long-distance travel, and ample luggage space for a hassle-free journey. With experienced drivers, flexible one-way and round-trip tour packages, transparent pricing, and 24/7 booking support, the Pune to Ayodhya tour package guarantees punctual, reliable, and stress-free travel. Choose Sanavi Travels for trusted Pune to Ayodhya bus tour services, delivering comfort, safety, and convenience for a memorable and divine pilgrimage experience.',

    top: 'Top Places to Visit in Ayodhya with Sanavi Travels',


"topPlaces": [
  {
    "title": "Ram Janmabhoomi Temple",
    "description": "The Ram Janmabhoomi Temple in Ayodhya is the sacred birthplace of Lord Rama and one of India’s most significant pilgrimage sites. Devotees from across the country visit to offer prayers and participate in rituals. The temple complex reflects a magnificent architectural design with intricate carvings, domes, and spacious courtyards. Visiting this temple is considered highly auspicious and spiritually uplifting for devotees of Lord Rama."
  },
  {
    "title": "Hanuman Garhi",
    "description": "Hanuman Garhi is an ancient temple dedicated to Lord Hanuman, located in the heart of Ayodhya. The temple is famous for its 76-step climb, offering panoramic views of the city. Devotees believe that worshipping here provides strength, courage, and protection from negative influences. Hanuman Garhi is especially vibrant during festivals like Hanuman Jayanti and Ram Navami."
  },
  {
    "title": "Kanak Bhawan",
    "description": "Kanak Bhawan is a historic temple dedicated to Lord Rama and his consort Sita, believed to have been gifted by Kaikeyi, Rama’s mother. The temple is adorned with golden and silver decorations, exquisite idols, and traditional architecture. It remains an important site for devotees seeking blessings and spiritual solace."
  },
  {
    "title": "Saryu River Ghats",
    "description": "The Saryu River flows gracefully through Ayodhya, and its ghats are central to religious and cultural activities. Devotees perform aarti, ritual baths, and offerings on the riverbanks. Sunrise and sunset along the Saryu create a serene and spiritual ambiance, making it a key attraction for visitors."
  },
  {
    "title": "Treta Ke Thakur",
    "description": "Treta Ke Thakur is an ancient temple where it is believed that Lord Rama performed rituals after his return from exile. The temple is renowned for its spiritual significance and beautiful carvings, attracting devotees and history enthusiasts alike."
  },
  {
    "title": "Guptar Ghat",
    "description": "Guptar Ghat is believed to be the site where Lord Rama took a holy dip in the Saryu River before leaving for his exile. This ghat is an important spiritual spot, with devotees offering prayers and seeking blessings while enjoying the peaceful river setting."
  },
  {
    "title": "Ram Katha Park",
    "description": "Ram Katha Park is a cultural and recreational space in Ayodhya dedicated to the stories and life of Lord Rama. The park features statues, sculptures, and landscaped areas that narrate episodes from the Ramayana, providing a blend of spirituality, education, and leisure for visitors."
  },
  {
    "title": "Nageshwarnath Temple",
    "description": "Nageshwarnath Temple is an ancient Shiva temple built by Raja Bharat, associated with the Ramayana legend. The temple features traditional architecture and intricate carvings. Devotees visit to seek blessings from Lord Shiva and experience spiritual tranquility."
  },
  {
    "title": "Ayodhya Museum",
    "description": "The Ayodhya Museum showcases the city’s rich historical, cultural, and religious heritage. Exhibits include ancient artifacts, sculptures, manuscripts, and models of temples. The museum provides visitors with deeper insights into Ayodhya’s spiritual and historical significance."
  },
  {
    "title": "Festivals and Religious Events",
    "description": "Ayodhya comes alive during major festivals such as Ram Navami, Diwali, and Hanuman Jayanti. The city hosts grand processions, cultural programs, devotional music, and religious rituals. Participating in these festivals offers devotees and tourists a profound spiritual and cultural experience."
  }
]
,



"services": [
{
"name": "Pune to Ayodhya Tour Package",
"description": "Pune to Ayodhya Tour Package offers a complete and well-planned pilgrimage experience for travelers visiting the holy city of Ayodhya. With organized itineraries, comfortable travel, and sightseeing arrangements, this package ensures a memorable spiritual journey."
},
{
"name": "Ayodhya Bus Hire from Pune",
"description": "Ayodhya Bus Hire from Pune provides convenient and reliable bus rental options for your pilgrimage or tour. Whether traveling with family, friends, or large groups, these buses ensure a safe and comfortable journey from Pune to Ayodhya."
},
{
"name": "AC Bus Pune to Ayodhya",
"description": "AC Bus Pune to Ayodhya ensures a cool and pleasant ride for long-distance travel. Fully air-conditioned buses with modern amenities provide a relaxing and stress-free journey for all passengers traveling to the sacred city."
},
{
"name": "Luxury Bus Ayodhya Darshan",
"description": "Luxury Bus Ayodhya Darshan offers premium travel options for pilgrims and tourists seeking extra comfort and convenience. With plush seating, spacious interiors, and professional chauffeurs, the journey to Ayodhya becomes a comfortable and memorable experience."
},
{
"name": "Religious Tour Bus Ayodhya",
"description": "Religious Tour Bus Ayodhya is designed for devotees visiting temples and spiritual sites in Ayodhya. Safe, well-maintained buses and experienced drivers ensure a smooth and organized religious tour."
},
{
"name": "Ram Mandir Darshan Bus",
"description": "Ram Mandir Darshan Bus provides specialized travel services for devotees visiting the iconic Ram Mandir in Ayodhya. Comfortable buses, reliable chauffeurs, and convenient schedules make the pilgrimage journey smooth and enjoyable."
},
{
"name": "Family Ayodhya Trip",
"description": "Family Ayodhya Trip buses are perfect for families seeking a comfortable and hassle-free journey. Spacious seating, safe travel, and friendly chauffeurs make it ideal for all age groups traveling from Pune to Ayodhya."
},
{
"name": "Group Travel Ayodhya Bus",
"description": "Group Travel Ayodhya Bus is ideal for large groups, tour operators, and devotees planning a collective pilgrimage. High-capacity buses and organized travel itineraries ensure a smooth and stress-free group journey."
},
{
"name": "Affordable Ayodhya Tour Package",
"description": "Affordable Ayodhya Tour Package offers budget-friendly travel options without compromising on comfort or safety. Perfect for students, families, and groups looking for economical yet comfortable pilgrimage travel."
},
{
"name": "Chauffeur Driven Bus Ayodhya",
"description": "Chauffeur Driven Bus Ayodhya provides professional drivers for a safe and relaxed long-distance journey. Passengers can enjoy the scenic route while experienced chauffeurs handle the road from Pune to Ayodhya."
},
{
"name": "Best Ayodhya Package Pune",
"description": "Best Ayodhya Package Pune is known for its well-organized travel arrangements, reliable buses, and exceptional customer service. Ideal for families, groups, and pilgrims seeking a seamless journey to Ayodhya."
},
{
"name": "Pune Ayodhya Travel Bus",
"description": "Pune Ayodhya Travel Bus offers fully managed travel services for pilgrims and tourists. Safe buses, comfortable seating, and professional drivers make the long-distance journey from Pune to Ayodhya enjoyable and stress-free."
},
{
"name": "Pilgrimage Bus Rental Pune",
"description": "Pilgrimage Bus Rental Pune specializes in providing buses for religious tours to Ayodhya and other spiritual destinations. These buses focus on safety, comfort, and convenience for all devotees and pilgrimage groups."
},
{
"name": "Online Bus Booking Ayodhya",
"description": "Online Bus Booking Ayodhya allows travelers to book buses from Pune to Ayodhya easily and quickly. Options include AC buses, luxury buses, and group travel buses, ensuring a hassle-free booking experience."
},
{
"name": "Spiritual Tour Bus",
"description": "Spiritual Tour Bus offers organized bus travel for long-distance pilgrimages and spiritual journeys from Pune to Ayodhya. Comfortable buses, experienced drivers, and planned itineraries ensure a peaceful and memorable travel experience."
}
],
"tableData": [
["Pune to Ayodhya Tour Package", "Ayodhya Bus Hire from Pune"],
["AC Bus Pune to Ayodhya", "Luxury Bus Ayodhya Darshan"],
["Religious Tour Bus Ayodhya", "Ram Mandir Darshan Bus"],
["Family Ayodhya Trip", "Group Travel Ayodhya Bus"],
["Affordable Ayodhya Tour Package", "Chauffeur Driven Bus Ayodhya"],
["Best Ayodhya Package Pune", "Pune Ayodhya Travel Bus"],
["Pilgrimage Bus Rental Pune", "Online Bus Booking Ayodhya"],
["Spiritual Tour Bus", "—"]
]
,


"whychoose": [
  {
    "WhyChooseheading": "Pune to Dwarka Bus On Rent with Sanavi Travels",
    "WhyChoosedescription": "Sanavi Travels provides comfortable and reliable bus rental services from Pune to Dwarka, ideal for group trips, pilgrimages, and long-distance travel."
  },
  {
    "WhyChooseheading": "Spacious and Well-Maintained Buses",
    "WhyChoosedescription": "Our buses are clean, air-conditioned, and regularly serviced to ensure a smooth and enjoyable journey from Pune to Dwarka."
  },
  {
    "WhyChooseheading": "Experienced Long-Distance Drivers",
    "WhyChoosedescription": "Our professional and licensed drivers are experienced in long-distance routes, ensuring safe, timely, and hassle-free travel."
  },
  {
    "WhyChooseheading": "Transparent Pricing with No Hidden Charges",
    "WhyChoosedescription": "Sanavi Travels offers clear pricing for Pune to Dwarka bus rentals, including fuel, tolls, and driver allowances, with no hidden fees."
  },
  {
    "WhyChooseheading": "24/7 Customer Support",
    "WhyChoosedescription": "Our support team is available around the clock to assist with bookings, itinerary planning, and travel queries during your Pune to Dwarka trip."
  },
  {
    "WhyChooseheading": "Customizable Travel Plans",
    "WhyChoosedescription": "Choose from one-way, round-trip, or customized bus rental packages based on your group’s schedule and preferences."
  },
  {
    "WhyChooseheading": "Safe and Sanitized Vehicles",
    "WhyChoosedescription": "All buses are thoroughly cleaned and sanitized before every trip to ensure a safe and hygienic travel experience."
  },
  {
    "WhyChooseheading": "Reliable and On-Time Service",
    "WhyChoosedescription": "We guarantee punctual pickups and dependable service, making Sanavi Travels a trusted choice for Pune to Dwarka bus rentals."
  }
]

}

const faqData = [
  {
    question: 'Does Sanavi Travels provide bus rental services from Pune to Dwarka?',
    answer: 'Yes, Sanavi Travels offers reliable and comfortable bus rental services for long-distance travel from Pune to Dwarka.'
  },
  {
    question: 'How can I book a Pune to Dwarka bus?',
    answer: 'You can book the bus via our website or by contacting our 24x7 customer support team.'
  },
  {
    question: 'What types of buses are available for Pune to Dwarka?',
    answer: 'We offer mini buses, 20-seater, 32-seater, 45-seater, and 50-seater buses depending on your group size.'
  },
  {
    question: 'Are the drivers experienced with long-distance travel?',
    answer: 'Yes, our drivers are licensed, professional, and familiar with long-distance routes like Pune to Dwarka.'
  },
  {
    question: 'Can I customize my travel itinerary?',
    answer: 'Absolutely, you can customize pickup points, stops, and travel schedule according to your needs.'
  },
  {
    question: 'Is customer support available during the journey?',
    answer: 'Yes, our 24x7 customer support team is available throughout your Pune to Dwarka trip.'
  },
  {
    question: 'Are the buses sanitized before the trip?',
    answer: 'Yes, all buses are thoroughly cleaned and sanitized to ensure a safe and hygienic journey.'
  },
  {
    question: 'What payment methods are accepted?',
    answer: 'We accept UPI, credit/debit cards, digital wallets, bank transfers, and corporate payments for booking.'
  },
  {
    question: 'Is this bus rental suitable for group travel?',
    answer: 'Yes, Pune to Dwarka bus rentals are ideal for families, groups, and long-distance pilgrimages.'
  }
];

const testimonials = [
  {
    id: 1,
    name: 'Mr. Anil Deshmukh',
    feedback: 'Our Pune to Dwarka trip with Sanavi Travels was smooth and comfortable. Excellent service and professional drivers!',
    rating: 5
  },
  {
    id: 2,
    name: 'Ms. Priyanka Sharma',
    feedback: 'Sanavi Travels made our long-distance journey easy and enjoyable. Highly recommend their bus rental service.',
    rating: 5
  }
];





















































































































































































  const Images = [
    { place: "/images/keyword/1.jpg", text: "Tempo Traveller On Rent in Pune", link: "tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/2.jpg", text: "Pune to Shirdi Tempo Traveller On Rent", link: "pune-to-shirdi-tempo-traveller-on-rent" },
    { place: "/images/keyword/3.jpg", text: "Pune to Mahabaleshwar Tempo Traveller on Rent", link: "pune-to-mahabaleshwar-tempo-traveller-on-rent" },
    { place: "/images/keyword/4.jpg", text: "Pune to Goa Tempo Traveller Hire", link: "pune-to-goa-tempo-traveller-hire" },
    { place: "/images/keyword/5.jpg", text: "Pune to Mumbai Tempo Traveller on Rent", link: "pune-to-mumbai-tempo-traveller-on-rent" },
    { place: "/images/keyword/6.jpg", text: "Pune to Konkan Darshan Tempo Traveller Hire", link: "pune-to-konkan-darshan-tempo-traveller-hire" },
    { place: "/images/keyword/7.jpg", text: "Pune to Nashik Tempo Traveller On Rent", link: "pune-to-nashik-tempo-traveller-on-rent" },
    { place: "/images/keyword/8.jpg", text: "Tempo Traveller On Rent for Pune Darshan", link: "tempo-traveller-on-rent-for-pune-darshan" },
    { place: "/images/keyword/9.jpg", text: "Mini Bus On Rent in Pune", link: "mini-bus-on-rent-in-pune" },
    { place: "/images/keyword/10.jpg", text: "13 Seater Tempo Traveller On Rent in Pune", link: "13-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/11.jpg", text: "17 Seater Tempo Traveller on Rent in Pune", link: "17-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/12.jpg", text: "20 Seater Luxury Bus On Rent Pune", link: "20-seater-luxury-bus-on-rent-pune" },
    { place: "/images/keyword/13.jpg", text: "26 Seater Tempo Traveller On Rent in Pune", link: "26-seater-tempo-traveller-on-rent-in-pune" },
    { place: "/images/keyword/14.jpg", text: "32 Seater Luxury Bus On Rent in Pune", link: "32-seater-luxury-bus-on-rent-in-pune" },
    { place: "/images/keyword/15.jpg", text: "35 Seater Bus on Rent in Pune", link: "35-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/16.jpg", text: "45 Seater Bus On Rent in Pune", link: "45-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/17.jpg", text: "50 Seater Bus On Rent in Pune", link: "50-seater-bus-on-rent-in-pune" },
    { place: "/images/keyword/18.jpg", text: "Bus Hire for School Trips in Pune", link: "bus-hire-for-school-trips-in-pune" },
    { place: "/images/keyword/19.jpg", text: "Bus booking for Wedding in Pune", link: "bus-booking-for-wedding-in-pune" },
    { place: "/images/keyword/20.jpg", text: "Bus Booking for Marriage in Pune", link: "bus-booking-for-marriage-in-pune" },
    { place: "/images/keyword/21.jpg", text: "Bus Service for Corporate in Pune", link: "bus-service-for-corporate-in-pune" },
    { place: "/images/keyword/22.jpg", text: "Bus on Rent For Event in Pune", link: "bus-on-rent-for-event-in-pune" },
    { place: "/images/keyword/23.jpg", text: "Bus Hire for Outstation in Pune", link: "bus-hire-for-outstation-in-pune" },
    { place: "/images/keyword/24.jpg", text: "AC Bus On Rent in Pune", link: "ac-bus-on-rent-in-pune" },
    { place: "/images/keyword/25.jpg", text: "Pune Bus Hire Rental Service", link: "pune-bus-hire-rental-service" },
  ];










const jsonData = {
  "@context": "https://schema.org",
  "@type": "BusTrip",
  "name": "Pune to Ayodhya Tour Package - Sanavi Travels",
  "description": "Sanavi Travels offers Pune to Ayodhya bus tour packages with AC and luxury buses. Ideal for religious trips, family visits, and group travel to Ram Mandir. Affordable, chauffeur-driven buses with online booking.",
  "touristType": "Family Trip, Group Travel, Pilgrimage, Religious Tourism",
  "departureLocation": "Pune",
  "arrivalLocation": "Ayodhya, Uttar Pradesh",
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.9",
    "ratingCount": "28"
  }
};






  return (
    <div>
<Helmet>
  <title>
    Pune to Ayodhya Tour Package | Sanavi Travels
  </title>

  <meta
    name="description"
    content="Pune to Ayodhya bus tour package by Sanavi Travels. AC and luxury buses for religious trips, Ram Mandir darshan, family visits, and group travel. Affordable and chauffeur-driven with online booking."
  />

  <script type="application/ld+json">
    {JSON.stringify(jsonData)}
  </script>
</Helmet>

      <div className="page-headder bg-section parallaxie">
        <div className="container">
          <div className="row">
            <div className="col-lg-12">
              <div className="page-header-box text-white">
                <h1 className="text-anime-style-3 text-center text-white" data-cursor="-opaque">
                  <h3> {cardData.keyword}</h3>
                </h1>
              </div>
            </div>
          </div>
        </div>
      </div>





      <section>
        <div className="container-fluid" >
          <div className="row container-fluid p-0">
            <div className="col-12 col-md-7 bg-foootr">
              <img src='/images/keyword/204.jpg' alt='img' className='img-fluid' />
              <h3 className="py-1"
                style={{
                  color: '#183765', // Red color for the title 
                  textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                  fontWeight: 'bold'
                }}


              >{cardData.heading} </h3><p className='fw-bold '>{cardData.headingDescription}</p>
              <div className="topPlaces">
                <p className="sectionLead">{cardData.top}</p>

                {cardData.topPlaces.map((place, index) => (
                  <article key={index} className="placeCard" tabIndex="0">
                    <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                    <div className="placeBody">
                      <h4 className="placeTitle">{place.title}</h4>
                      <p className="placeDesc">{place.description}</p>
                    </div>

                    <span className="placeArrow" aria-hidden>›</span>
                  </article>
                ))}
              </div>



              <div className="shambhu-services">
                {cardData.services.map((service, index) => (
                  <div key={index} className="sh-service-card">

                    <div className="sh-service-left">
                      <div className="sh-service-icon">
                        🚖
                      </div>
                    </div>

                    <div className="sh-service-content">
                      <h4 className="sh-service-title">{service.name}</h4>
                      <p className="sh-service-desc">{service.description}</p>
                    </div>

                  </div>
                ))}
              </div>


              <table className="table table-responsive Border-key my-2">
                <tbody className=' Border-key'>
                  {cardData.tableData.map((row, rowIndex) => (
                    <tr className='Border-key ' key={rowIndex}>
                      {row.map((cell, cellIndex) => (
                        <td key={cellIndex} className=' Border-key bluecolor fw-bold' >{cell}</td>
                      ))}
                    </tr>
                  ))}
                </tbody>
              </table>
              <h3 className='pt-md-3'>{cardData.keyword + " Rates"}</h3>
              <BusRatesTable />

              <div id="why-choose-section" className="why-choose-section">


                {/* Section Title */}
                <h2 className="section-title">
                  Why Choose <span>Sanavi Travels </span>
                </h2>

                {/* Cards */}
                <div className="cards-grid">
                  {cardData.whychoose.map((item, index) => (
                    <div key={index} className="why-card">
                      <div className="icon-circle">{index + 1}</div>
                      <h4 className="card-heading">{item.WhyChooseheading}</h4>
                      <p className="card-desc">{item.WhyChoosedescription}</p>
                    </div>
                  ))}
                </div>
              </div>



              <div className="row twm-faq-section-1 m-b30">


                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                  <div className="twm-faq-info-wrap">

                    <div className="section-head left">
                      <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Sanavi Travels </h2>
                    </div>


                    <div className="twm-faq-info">
                      <div className="accordion twm-acdn" id="sf-faq-accordion">

                        <FaqSection
                          title="Frequently Asked"
                          subtitle="Help & Info"
                          items={faqData}
                        />

                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <TestimonialSectionKeyword
                testimonials={testimonials}
              />


              <ContactShowcase />
            </div>

            <div className='col-12 col-md-4' >
              <div className="routeList">
                {Images.map((e, i) => {
                  const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                  const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                  return (
                    <a
                      key={e.link || i}
                      href={href}
                      className="routeItem"
                      aria-label={e.text}
                      {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                    >
                      <div className="routeThumb">
                        <img src={e.place} alt="" loading="lazy" />
                      </div>

                      <div className="routeMeta">
                        <h6 className="routeTitle">{e.text}</h6>
                        <span className="routeUnderline" />
                      </div>

                      <span className="routeArrow" aria-hidden>›</span>
                    </a>
                  );
                })}
              </div>




              <div>
                <FleetHighway />
              </div>
              <div className="pc-contact">
                <h4 className="pc-title">Contact Information</h4>

                <div className="pc-grid">
                  {/* Phones */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-telephone-fill"></i>
                      <span>Phone Numbers</span>
                    </header>

                    <div className="pc-list">
                      <a href="tel:+917387507373" className="pc-call">+91 7387507373</a>
                      <a href="tel:+919595532929" className="pc-call">+91 9595532929</a>
                    </div>

                    <div className="pc-cta">
                      <a
                        href="https://wa.me/917387507373"
                        target="_blank" rel="noopener noreferrer"
                        className="pc-whats"
                      >
                        <i className="bi bi-whatsapp me-1"></i> WhatsApp
                      </a>
                      <a href="tel:+917387507373" className="pc-primary">
                        Call Now
                      </a>
                    </div>
                  </section>

                  {/* Email */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-envelope-fill"></i>
                      <span>Email</span>
                    </header>

                    <a href="mailto:booking@sanavitravels.com" className="pc-email">
                      booking@sanavitravels.com
                    </a>
                  </section>

                  {/* Address */}
                  <section className="pc-tile">
                    <header className="pc-tile-head">
                      <i className="bi bi-house-fill"></i>
                      <span>Address</span>
                    </header>

                    <address className="pc-address">
                      <strong>Sanavi Travels</strong><br />
                      OFFICE NO.6, GROUND FLOOR GAT NO.1110,
                      SHREE GOPINATH MAHARAJ VYAPARI SHED SHIVAJI CHOWK, VARVAND TAL DAUND,
                      DIST PUNE – 412215
                    </address>
                  </section>
                </div>
              </div>


            </div>
          </div>
        </div>
      </section>


    </div>
  );
}

export default Punetoayodhyatourpackages;